import { URL } from "./URL";
import { useQuery } from "@tanstack/react-query";
import API from "./api";

export const postChangePassword = (token, senhas) => {
	return API.post(URL.AUTH.CHANGE_PASSWORD, senhas, {
		headers: {
			Authorization: `Token ${token}`,
			"Content-type": "application/json",
		},
	});
};

export const postEditProfile = (token, user) => {
	return API.put(URL.PROFILE.EDIT_PROFILE, user, {
		headers: {
			Authorization: `Token ${token}`,
			"Content-type": "application/json",
		},
	});
};

export const getProfile = (token) => {
	return API.get(URL.PROFILE.VIEW, {
		headers: {
			Authorization: `Token ${token}`,
			"Content-type": "application/json",
		},
	});
};

// Custom Hook

const getData = async (token) => {
	const { data } = await getProfile(token);
	return data;
};

export const useGetProfile = (token) => {
	return useQuery(["get-profile"], () => getData(token));
};
